import { api } from '@/utils'
import { CLIENT_CODE } from '@/constants'

import { Params, Response, Service } from '.'

const login = async (params: Params): Promise<Response> => {
	try {
		const formData = new FormData()
		formData.append('client_code', CLIENT_CODE)
		formData.append('password', params.password)
		if (params.email) formData.append('email', params.email)
		if (params.phone) formData.append('phone', params.phone)
		if (params.barcode) formData.append('barcode', params.barcode)

		const res = await api.post<Response>('login', formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
				Accept: 'application/json'
			},
			transformRequest: data => data
		})
		return res.data
	} catch (e) {
		throw e
	}
}

export const service: Service = {
	login
}
